// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3io_h","productName":"Table_productName__3pBT-"};